import { connect } from "react-redux";
import { getPODs, updateExtras } from "../../actions";
import { Dropdown, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import CURRENCY_UNITS from "../../../assets/currency-units.json";
import React, { useEffect, useState } from "react";
import { ReactComponent as Check } from "../../../assets/check.svg";
import { parseError } from "../../actions/ActionHelpers";
import ProofOfDeliveryConfig from "./ProofOfDeliveryConfig";
import Accordion from "react-bootstrap/Accordion";
import { LuMinus } from "react-icons/lu";
import { FiInfo } from "react-icons/fi";
import { isDomesticKenyanShipment } from "../common/helpers";

const ExtraOptions = (props) => {
  const [showPOD, setShowPOD] = useState(false);
  const [showCOD, setShowCOD] = useState(
    parseFloat(props.selectedExtras?.collection_on_delivery?.amount) > 0 ||
      false,
  );
  const [activeKey, setActiveKey] = useState(null);
  const {
    allowExtras,
    getPODs,
    pickupPoint,
    pickupEnabled,
    PODs,
    requireApproval,
    requireSignature,
    receiverForChecks,
    selectedExtras,
    sender,
    receiver,
    updateExtras,
  } = props;
  const codAmount = selectedExtras?.collection_on_delivery?.amount;
  const pickupActive = Boolean(pickupEnabled && pickupPoint?.id);
  const destinationReceiver = receiverForChecks || receiver;

  // Make sure COD is only available for Kenya
  const isLocalKenya = isDomesticKenyanShipment(
    sender,
    destinationReceiver,
    pickupActive ? pickupPoint : null,
  );

  useEffect(() => {
    getPODs();
  }, [getPODs]);

  useEffect(() => {
    if (pickupActive) {
      updateExtras("require_signature", true);
      updateExtras("require_parcel_photo", true);
      updateExtras("require_id", true);
      updateExtras("requires_pod_approval", undefined);
      updateExtras("allow_extra_pods", undefined);
      updateExtras("delivery_rules", undefined);
      setActiveKey("0");
      return;
    } else if (isLocalKenya) {
      updateExtras("require_signature", pickupActive ? true : requireSignature);
      const requiredPODs = PODs.filter((pod) => pod.is_required === true);
      if (requiredPODs.length === 0) return;
      updateExtras("requires_pod_approval", requireApproval);
      updateExtras("allow_extra_pods", allowExtras);
      updateExtras("delivery_rules", requiredPODs);
    } else {
      updateExtras("requires_pod_approval", undefined);
      updateExtras("allow_extra_pods", undefined);
      updateExtras("delivery_rules", undefined);
    }
  }, [
    allowExtras,
    isLocalKenya,
    pickupActive,
    PODs,
    requireApproval,
    requireSignature,
    updateExtras,
  ]);

  useEffect(() => {
    setShowCOD((prevShowCOD) => {
      if (pickupActive) {
        return false;
      }
      if (!prevShowCOD) {
        return !!parseFloat(codAmount) > 0;
      }
      return prevShowCOD;
    });
  }, [codAmount, pickupActive]);

  const getRequiredPODState = () => {
    const {
      selectedExtras: {
        requires_pod_approval,
        allow_extra_pods,
        delivery_rules,
      },
      PODs,
    } = props;
    const selectedPodIds = delivery_rules?.map((p) => p.id) || [];
    const totalPods = PODs?.length;
    const selectedCount = PODs.filter((pod) =>
      selectedPodIds.includes(pod.id),
    ).length;

    if (!requires_pod_approval && !allow_extra_pods && selectedCount === 0) {
      return "none";
    }

    if (
      selectedCount === totalPods &&
      requires_pod_approval &&
      allow_extra_pods
    ) {
      return "all";
    }

    return "some";
  };
  const requiredPODState = getRequiredPODState();

  const toggleSelectedPOD = (pod) => {
    const { selectedExtras, updateExtras } = props;
    if (!selectedExtras.delivery_rules) {
      updateExtras("delivery_rules", [pod]);
      return;
    }
    const exists = selectedExtras.delivery_rules?.some((p) => p.id === pod.id);

    const newPODs = exists
      ? selectedExtras.delivery_rules?.filter((p) => p.id !== pod.id) // remove
      : [...selectedExtras.delivery_rules, pod]; // add

    updateExtras("delivery_rules", newPODs);
  };

  return (
    <div className="extra-options">
      <div className={" template-fields"}>
        {props.template && isLocalKenya && (
          <div
            className={`check-template  p-0 d-flex justify-content-center align-items-center ${props.checkCOD ? "active" : ""}`}
          >
            <div
              className="template-checkbox d-flex justify-content-center align-items-center"
              onClick={() =>
                props.toggleCOD(props.selectedExtras?.collection_on_delivery)
              }
            >
              <Check />
            </div>
          </div>
        )}
        <div>
          {isLocalKenya && !pickupActive && (
            <label
              className={"form-checkbox align-self-start"}
              onClick={() => {
                setShowCOD(!showCOD);
                if (showCOD) {
                  props.updateExtras("collection_on_delivery", undefined);
                } else {
                  props.updateExtras("collection_on_delivery", {
                    currency:
                      props.selectedOrder?.currency ||
                      props.savedCOD?.currency ||
                      "KES",
                    amount:
                      props.selectedOrder?.amount_remaining ||
                      props.savedCOD?.amount ||
                      null,
                  });
                }
              }}
            >
              <div className={`check mr-2 ${showCOD ? "active" : ""}`}>
                <Check />
              </div>
              <p>This shipment has amount to be collected on delivery</p>
            </label>
          )}
          {showCOD && isLocalKenya && !pickupActive && (
            <div
              className={"d-flex flex-row justify-content-between mb-3  gap-3"}
            >
              <label
                className={`d-flex flex-column flex-grow-1 mb-3 pr-3 ${props.errors?.collection_on_delivery ? "show-error" : ""}`}
              >
                <p className={"package-prompt"}>
                  Amount to be collected on delivery
                </p>
                <input
                  type={"number"}
                  onWheel={(e) => {
                    e.target.blur();
                  }}
                  onScroll={(e) => {
                    e.target.blur();
                  }}
                  min={1}
                  value={props.selectedExtras?.collection_on_delivery?.amount}
                  onChange={(e) => {
                    props.updateExtras("collection_on_delivery", {
                      currency:
                        props.selectedExtras?.collection_on_delivery
                          ?.currency || "KES",
                      amount: parseFloat(e.target.value),
                    });
                  }}
                />
                {props.errors?.collection_on_delivery && (
                  <p className={"text-danger"}>
                    {parseError(props.errors?.collection_on_delivery)}
                  </p>
                )}
              </label>
              <label>
                <p>&nbsp;</p>
                <Dropdown>
                  <Dropdown.Toggle className="col-12 p-0 px-3 d-flex flex-row justify-content-between align-items-center">
                    {props.selectedExtras.collection_on_delivery?.currency}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {Object.keys(CURRENCY_UNITS).map((currency) => {
                      return (
                        <Dropdown.Item
                          key={currency}
                          onClick={() => {
                            props.updateExtras("collection_on_delivery", {
                              currency,
                              amount:
                                props.selectedExtras?.collection_on_delivery
                                  ?.amount || 0,
                            });
                          }}
                        >
                          {currency}
                        </Dropdown.Item>
                      );
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              </label>
            </div>
          )}
        </div>
      </div>
      <div className={" template-fields"}>
        {props.template && (
          <div
            className={`check-template  p-0 d-flex justify-content-center align-items-center ${props.checkSignature ? "active" : ""}`}
          >
            <div
              className="template-checkbox d-flex justify-content-center align-items-center"
              onClick={() =>
                props.toggleSignature(props.selectedExtras?.require_signature)
              }
            >
              <Check />
            </div>
          </div>
        )}
        <label
          className={"form-checkbox disables"}
          onClick={() => {
            if (pickupActive) return;
            props.updateExtras(
              "require_signature",
              !props.selectedExtras?.require_signature,
            );
          }}
        >
          <div
            className={`check mr-2 ${props.selectedExtras?.require_signature ? "active" : ""}`}
          >
            <Check />
          </div>
          <p>
            Requires Signature
            {pickupActive ? (
              <OverlayTrigger
                key={"pod-tooltip"}
                placement="auto"
                overlay={
                  <Tooltip id="pod-tooltip" className={"checkout-address-info"}>
                    {"Signature is required for pickup point deliveries"}
                  </Tooltip>
                }
                delayShow={300}
                delayHide={150}
              >
                <span className={"pod-tooltip"}>
                  <FiInfo className={"warning mx-2"} />
                </span>
              </OverlayTrigger>
            ) : null}
          </p>
        </label>
      </div>

      {isLocalKenya ? (
        <Accordion activeKey={activeKey}>
          <Accordion.Item eventKey={"0"}>
            <div
              className={`form-checkbox ${!props.PODs?.length && !pickupActive ? "disabled" : ""}`}
            >
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  if (pickupActive) {
                    return;
                  }
                  if (requiredPODState === "none" && props.PODs.length > 0) {
                    props.updateExtras("requires_pod_approval", true);
                    props.updateExtras("allow_extra_pods", true);
                    props.updateExtras("delivery_rules", props.PODs);
                    setActiveKey("0");
                  } else {
                    props.updateExtras("requires_pod_approval", false);
                    props.updateExtras("allow_extra_pods", false);
                    props.updateExtras("delivery_rules", undefined);
                  }
                }}
                className={`check mr-2 ${requiredPODState !== "none" || props.selectedExtras.require_parcel_photo ? "active" : ""}`}
              >
                {!props.selectedExtras.require_parcel_photo &&
                requiredPODState === "some" ? (
                  <LuMinus color={"white"} />
                ) : (
                  <Check />
                )}
              </div>
              <Accordion.Header
                as={"div"}
                className={"pod-status "}
                onClick={() => {
                  if (props.PODs.length > 0 || pickupActive)
                    setActiveKey(activeKey ? null : "0");
                }}
              >
                <div
                  className={
                    "d-flex flex-row align-items-center justify-content-between w-100"
                  }
                >
                  <div className={"d-flex flex-row align-items-center "}>
                    <p>Require Proof of Delivery</p>
                    {!props.PODs?.length && !pickupActive ? (
                      <OverlayTrigger
                        key={"pod-tooltip"}
                        placement="auto"
                        overlay={
                          <Tooltip
                            id="pod-tooltip"
                            className={"checkout-address-info"}
                          >
                            {
                              "Click 'Configure' to add additional proof of delivery requirements"
                            }
                          </Tooltip>
                        }
                        delayShow={300}
                        delayHide={150}
                      >
                        <span className={"pod-tooltip"}>
                          <FiInfo className={"warning mx-2"} />
                        </span>
                      </OverlayTrigger>
                    ) : null}
                  </div>

                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      if (props.podLoading) return;
                      setShowPOD(true);
                    }}
                  >
                    {props.podLoading ? (
                      <Spinner animation={"border"} size={"sm"} />
                    ) : (
                      "Configure"
                    )}
                  </button>
                </div>
              </Accordion.Header>
            </div>

            <Accordion.Body className={"p-3"}>
              {pickupActive ? (
                <>
                  <label className={"form-checkbox"}>
                    <div
                      className={`check mr-2 ${props.selectedExtras.require_parcel_photo ? "active" : ""}`}
                    >
                      <Check />
                    </div>
                    <p>
                      Requires Parcel Photo
                      <OverlayTrigger
                        key={"parcel-photo-tooltip"}
                        placement="auto"
                        overlay={
                          <Tooltip
                            id="parcel-photo-tooltip"
                            className={"checkout-address-info"}
                          >
                            {
                              "Parcel photo is required for pickup point deliveries"
                            }
                          </Tooltip>
                        }
                        delayShow={300}
                        delayHide={150}
                      >
                        <span className={"pod-tooltip"}>
                          <FiInfo className={"warning mx-2"} />
                        </span>
                      </OverlayTrigger>
                    </p>
                  </label>
                  <label className={"form-checkbox"}>
                    <div
                      className={`check mr-2 ${props.selectedExtras.require_id ? "active" : ""}`}
                    >
                      <Check />
                    </div>
                    <p>
                      Requires ID
                      <OverlayTrigger
                        key={"require-id-tooltip"}
                        placement="auto"
                        overlay={
                          <Tooltip
                            id="require-id-tooltip"
                            className={"checkout-address-info"}
                          >
                            {
                              "ID verification is required for pickup point deliveries"
                            }
                          </Tooltip>
                        }
                        delayShow={300}
                        delayHide={150}
                      >
                        <span className={"pod-tooltip"}>
                          <FiInfo className={"warning mx-2"} />
                        </span>
                      </OverlayTrigger>
                    </p>
                  </label>
                </>
              ) : (
                <>
                  <label
                    className={"form-checkbox "}
                    onClick={() =>
                      props.updateExtras(
                        "requires_pod_approval",
                        !props.selectedExtras.requires_pod_approval,
                      )
                    }
                  >
                    <div
                      className={`check mr-2 ${props.selectedExtras.requires_pod_approval ? "active" : ""}`}
                    >
                      <Check />
                    </div>
                    <p>Requires Approval</p>
                  </label>
                  <label
                    className={"form-checkbox "}
                    onClick={() =>
                      props.updateExtras(
                        "allow_extra_pods",
                        !props.selectedExtras.allow_extra_pods,
                      )
                    }
                  >
                    <div
                      className={`check mr-2 ${props.selectedExtras.allow_extra_pods ? "active" : ""}`}
                    >
                      <Check />
                    </div>
                    <p>Allow Extras</p>
                  </label>
                  {props.PODs.map((pod) => {
                    return (
                      <label
                        className={"form-checkbox "}
                        onClick={() => toggleSelectedPOD(pod)}
                        key={pod.id}
                      >
                        <div
                          className={`check mr-2 ${props.selectedExtras.delivery_rules?.find((selectedPOD) => selectedPOD.id === pod.id) ? "active" : ""}`}
                        >
                          <Check />
                        </div>
                        <p>{pod.name}</p>
                      </label>
                    );
                  })}
                </>
              )}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      ) : null}

      <div className={`d-flex flex-row mt-3`}>
        {!props.template && (
          <label
            className={`d-flex flex-column col-6 pl-0  ${props.errors?.reference_1 ? "show-error" : ""}`}
          >
            <p className="package-prompt mb-2">Reference 1</p>
            <input
              value={props.selectedExtras?.reference_1}
              onChange={(text) =>
                props.updateExtras("reference_1", text.target.value)
              }
            />

            {props.errors?.reference_1 && (
              <p className={"text-danger"}>{props.errors?.reference_1}</p>
            )}
          </label>
        )}

        {!props.template && (
          <label
            className={`d-flex flex-column col-6 p-0 ${props.errors?.reference_2 ? "show-error" : ""}`}
          >
            <p className="package-prompt mb-2">Reference 2</p>
            <input
              value={props.selectedExtras?.reference_2}
              onChange={(text) =>
                props.updateExtras("reference_2", text.target.value)
              }
            />

            {props.errors?.reference_2 && (
              <p className={"text-danger"}>{props.errors?.reference_2}</p>
            )}
          </label>
        )}
      </div>

      {!props.template && (
        <label
          className={`d-flex flex-column ${props.errors?.description ? "show-error" : ""}`}
        >
          <p className="package-prompt mb-2">Description</p>
          <input
            value={props.selectedExtras?.description}
            onChange={(text) => {
              props.updateExtras("description", text.target.value);
            }}
            className={"mb-2"}
          />
          {props.errors?.description && (
            <p className={"text-danger"}>{props.errors?.description}</p>
          )}
        </label>
      )}
      {showPOD ? (
        <ProofOfDeliveryConfig close={() => setShowPOD(false)} />
      ) : null}
    </div>
  );
};

const mapStateToProps = ({
  parcels,
  senderAddress,
  receiverAddress,
  stores,
  labelTemplate,
  pod,
  applicationContext,
  pickupPoint,
}) => ({
  selectedExtras: parcels.selectedExtras,
  selectedOrder: stores.selectedOrder,
  sender: senderAddress,
  receiver: receiverAddress,
  savedCOD:
    labelTemplate.selectedTemplate?.selectedExtras?.collection_on_delivery,
  PODs: pod.pods,
  requireSignature: pod.require_signature,
  requireApproval: pod.require_pod_approval,
  requireParcelPhoto: pod.require_parcel_photo,
  allowExtras: pod.allow_extra_pods,
  podLoading: pod.loading,
  auth: applicationContext.context.auth,
  pickupPoint: pickupPoint.pickupPoint,
});

export default connect(mapStateToProps, {
  updateExtras,
  getPODs,
})(ExtraOptions);
